import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import score from 'src/helper/score'
import {
  shareToLink,
  shareToWhatsapp,
  shareToSnap,
  shareToIns,
  shareToFaceBook
} from 'src/helper/webviewFun'

import {
  apiGetShareLink
} from 'src/helper/gold.js'

import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper-bundle.min.css';

import Toast from '../../../component/Toast'
import CD from 'src/component/CountDown'
import RuleButton from '../../../component/RuleButton'

@inject('store')
@observer

export default class extends Component {
  constructor(props) {
    super(props)
    this.ramadan = this.props.store.register('activity/ramadan')
    setDocumentTitle('Ramadan Activity')
  }

  state = {
    lang: langM.ar,
    rwIndex: 1,
    taskList: null,
    chipList: null,
    shareState: false,
    desc: "",
    language:'en',
    codeMain: null,
    chips: null,
    chipsList: [],
    isCanGet1: false,
    isCanGet2: false,
    isCanGet3: false,
    isCanGet4: false,
    cd: 0
  }

  async componentWillMount() {
    // 控制台调试
    // ()
    let { language } = this.props.location.query
    language =await getlang(language)
    console.log('language', language)
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })

    // 登录信息
    let uid = await setUidToken(this.props.location.query)
    let useInfo = await this.ramadan.GetUserInfoWeb(uid)


    let cd = await this.ramadan.jigsawCd()
    this.setState({
      cd: cd
    })

    // 拼图展示
    // 初始化任务列表展示
    let chipList = await this.ramadan.getJigsawListNow()
    let task = await this.ramadan.getJigsawTask()


    // 初始化碎片展示
    // 初始化碎片列表展示
    this.initChips()

    // 初始化分享码
    let userCode = await this.ramadan.getCode()
    let shareCode = window.location.origin + `/#/activity/ramadanHelp?code=${userCode}`
    console.log(shareCode)

    // 任务添加说明
    task.map((item, i) => {
      if (task[i].taskType == 1) {
        task[i].desc = this.state.lang.task1
      }
      else if (task[i].taskType == 2) {
        task[i].desc = this.state.lang.task2
      }
      else if (task[i].taskType == 3) {
        task[i].desc = this.state.lang.task3
      }
      else if (task[i].taskType == 4) {
        task[i].desc = this.state.lang.task4
      }
    })

    this.setState({
      taskList: task,  // 初始化任务列表展示
      chipList: chipList,  // 拼图展示
      codeMain: shareCode,  // 初始化分享码
    })


    await this.RunOnStart(uid)
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // 用户id
    this.setState({
      uid: uid
    })

    let rwObjList = await this.ramadan.getJigsawRewardObj()
    console.log(rwObjList, 'rwObjList')
    if (rwObjList && rwObjList[0] && rwObjList[0].canGet) {
      this.setState({
        isCanGet1: true
      })
    }
    this.setState({
      rwObjList: rwObjList
    })
    // let res = await this.ramadan.getJigsawReward()
  }

  async initChips() {
    let chips = await this.ramadan.getChip()
    let list = []
    for (let i = 0; i < chips.fragment; i++) {
      list.push(1)
    }
    this.setState({
      chips: chips.fragment,   // 初始化碎片展示
      chipsList: list,  // 初始化碎片列表展示
    })
  }

  componentDidMount() {

  }

  timeComp({ langtxt, daytxt, day, hour, mi, se }) {
    return (
      <div className="timer">
        <div className="d time-box"></div>
        <div className="d time-box"></div>
        <div className="d time-box"></div>
        <div className="d time-box"></div>
        <div className="d time-box">
          {day}
        </div>
        <div className="d time-box">
          Day
        </div>
        <div className="h time-box">
          {hour}
        </div>
        <div>
          :
        </div>
        <div className="m time-box">
          {mi}
        </div>
        <div>
          :
        </div>
        <div className="s time-box">
          {se}
        </div>
      </div>
    )
  }

  cdComp() {
    return (
      <div className="ramadan-jigsaw-cd">
        <CD leftTimestamp={this.state.cd} slot={this.timeComp} />
      </div>
    )
  }

  ruleContentComp = (open, close, lang) => {
    return (
      <div className="ramadan-jigsaw-banner-rule-content-main" onClick={() => { close() }}>
        <div className="ramadan-jigsaw-banner-rule-title">
          {lang.rules}
        </div>
        <div className="ramadan-jigsaw-banner-rule-content"
          style={{
            direction: `${this.state.language == 'ar' ? "rtl" : ""}`
          }}
          dangerouslySetInnerHTML={{ __html: this.state.lang.ruleContent }}></div>
      </div>
    )
  }

  isRwCanGet() {
    const rw1 = this.state.rwObjList && this.state.rwObjList[0]
    const rw2 = this.state.rwObjList && this.state.rwObjList[1]
    const rw3 = this.state.rwObjList && this.state.rwObjList[2]
    const rw4 = this.state.rwObjList && this.state.rwObjList[3]
    const can1 = rw1 && rw1.isGet
    const can2 = rw2 && rw2.isGet
    const can3 = rw3 && rw3.isGet
    const can4 = rw4 && rw4.isGet
    if (!can1 && this.state.rwIndex == 1) {
      setTimeout(() => {
        this.setState({
          isCanGet1: true
        })
      }, 100);
    } else {
      this.setState({
        isCanGet1: false
      })
    }
    if (!can2 && this.state.rwIndex == 2) {
      setTimeout(() => {
        this.setState({
          isCanGet2: true
        })
      }, 100);
    } else {
      this.setState({
        isCanGet2: false
      })
    }
    if (!can3 && this.state.rwIndex == 3) {
      setTimeout(() => {
        this.setState({
          isCanGet3: true
        })
      }, 100);
    } else {
      this.setState({
        isCanGet3: false
      })
    }
    if (!can4 && this.state.rwIndex == 4) {
      setTimeout(() => {
        this.setState({
          isCanGet4: true
        })
      }, 100);
    } else {
      this.setState({
        isCanGet4: false
      })
    }
  }

  bannerComp() {
    const rw1 = this.state.rwObjList && this.state.rwObjList[0]
    const rw2 = this.state.rwObjList && this.state.rwObjList[1]
    const rw3 = this.state.rwObjList && this.state.rwObjList[2]
    const rw4 = this.state.rwObjList && this.state.rwObjList[3]

    return (
      <div className="ramadan-jigsaw-banner">
        <div className="ramadan-jigsaw-banner-reward-step">
          <Swiper slidesPerView={3}
            onClick={(e) => {
              if (e.clickedIndex == 0 || e.clickedIndex == 5) {
                return
              }
              this.setState({
                rwIndex: e.clickedIndex
              })
              e.slideTo(this.state.rwIndex - 1)
              this.isRwCanGet()
            }}
            onReachEnd={() => { return }}
            // 滑动监听
            onSlideChange={(e) => {
              this.setState({ rwIndex: e.activeIndex + 1 })
              this.isRwCanGet()
            }}>
            <SwiperSlide></SwiperSlide>
            <SwiperSlide>
              <div className={`light ${this.state.rwIndex == 1 ? "hd" : ""}`} onClick={(e) => { e.preventDefault() }}>
                <img className='pic' src="/img/gold.png" alt="" style={{ transform: `scale(${this.state.rwIndex == 1 ? "1" : "0.8"})` }} />
                <div className="light-active" style={{ display: `${this.state.rwIndex == 1 ? "block" : "none"}` }}></div>

                <div className={`light-active2 ${this.state.rwIndex == 1 ? "" : "light-active22"}`} style={{ display: `${rw1 && rw1.canGet ? "block" : "none"}` }}></div>

                {
                  this.state.isCanGet1 && rw1 && rw1.canGet && (<div className={`star ${rw1 && rw1.canGet && "star-active"}`} onClick={() => { this.onGetReward(1) }}>{this.state.lang.get}</div>)
                }
                {
                  this.state.rwIndex == 1 && rw1 && rw1.isGet && (<div className={`star ${rw1 && rw1.canGet && "star-active"}`}>{this.state.lang.getDown}</div>)
                }
                <div className={`goods-name ${this.state.rwIndex == 1 && "goods-name-active"}`}>100</div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={`light ${this.state.rwIndex == 2 ? "hd" : ""}`} onClick={(e) => { e.preventDefault() }}>
                <img className='pic' src="/img/activity/ramadan/help/rw/gift.png" alt="" style={{ transform: `scale(${this.state.rwIndex == 2 ? "1" : "0.8"})` }} />
                <div className="light-active" style={{ display: `${this.state.rwIndex == 2 ? "block" : "none"}` }}></div>

                <div className={`light-active2 ${this.state.rwIndex == 2 ? "" : "light-active22"}`} style={{ display: `${rw2 && rw2.canGet ? "block" : "none"}` }}></div>

                {
                  this.state.isCanGet2 && rw2 && rw2.canGet && (<div className={`star ${rw2 && rw2.canGet && "star-active"}`} onClick={() => { this.onGetReward(2) }}>{this.state.lang.get}</div>)
                }
                {
                  this.state.rwIndex == 2 && rw2 && rw2.isGet && (<div className={`star ${rw2 && rw2.canGet && "star-active"}`}>{this.state.lang.getDown}</div>)
                }
                <div className={`goods-name ${this.state.rwIndex == 2 && "goods-name-active"}`}>Gift</div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={`light ${this.state.rwIndex == 3 ? "hd" : ""}`} onClick={(e) => { e.preventDefault() }}>
                <img className='pic' src="/img/activity/ramadan/help/rw/h.png" alt="" style={{ transform: `scale(${this.state.rwIndex == 3 ? "1" : "0.8"})` }} />
                <div className="light-active" style={{ display: `${this.state.rwIndex == 3 ? "block" : "none"}` }}></div>

                <div className={`light-active2 ${this.state.rwIndex == 3 ? "" : "light-active22"}`} style={{ display: `${rw3 && rw3.canGet ? "block" : "none"}` }}></div>

                {
                  this.state.isCanGet3 && rw3 && rw3.canGet && (<div className={`star ${rw3 && rw3.canGet && "star-active"}`} onClick={() => { this.onGetReward(3) }}>{this.state.lang.get}</div>)
                }
                {
                  this.state.rwIndex == 3 && rw3 && rw3.isGet && (<div className={`star ${rw3 && rw3.canGet && "star-active"}`}>{this.state.lang.getDown}</div>)
                }
                <div className={`goods-name ${this.state.rwIndex == 3 && "goods-name-active"}`}>Head *5D</div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={`light ${this.state.rwIndex == 4 ? "hd" : ""}`} onClick={(e) => { e.preventDefault() }}>
                <div className="reward-box">
                  <img className={`rw-item`} src="https://d12o7ht18lg4ku.cloudfront.net/app/noble/viscount.png" alt="" />
                  <img className={`rw-item`} src="/img/activity/ramadan/help/rw/m.png" alt="" />
                  <img className={`rw-item`} src="/img/activity/ramadan/help/rw/c.png" alt="" />
                </div>
                <div className="light-active" style={{ display: `${this.state.rwIndex == 4 ? "block" : "none"}` }}></div>

                <div className={`light-active2 ${this.state.rwIndex == 4 ? "" : "light-active22"}`} style={{ display: `${rw4 && rw4.canGet ? "block" : "none"}` }}></div>

                {
                  this.state.isCanGet4 && rw4 && rw4.canGet && (<div className={`star ${rw4 && rw4.canGet && "star-active"}`} onClick={() => { this.onGetReward(4) }}>{this.state.lang.get}</div>)
                }
                {
                  this.state.rwIndex == 4 && rw4 && rw4.isGet && (<div className={`star ${rw4 && rw4.canGet && "star-active"}`}>{this.state.lang.getDown}</div>)
                }
                <div className={`goods-name ${this.state.rwIndex == 4 && "goods-name-active"}`}>VIP1、Medal、Car *7D</div>
              </div>
            </SwiperSlide>
            <SwiperSlide></SwiperSlide>
          </Swiper>
        </div>

      </div>
    )
  }

  async onGetReward(val) {
    let res = await this.ramadan.getJigsawReward(val)
    console.log(res)
    let rwObjList = await this.ramadan.getJigsawRewardObj()
    console.log(rwObjList, 'rwObjList')
    if (res == 0) {
      this.setState({
        desc: this.state.lang.getSuc,
        rwObjList: rwObjList,
      })
      this.refs.toast.hideRule(true)
    }
  }

  async onUnLockJigsaw() {
    if (this.state.chipList.length >= 9) {
      this.setState({
        desc: this.state.lang.ptDown
      })
      this.refs.toast.hideRule(true)
      return
    }
    if (this.state.chips == 0) {
      this.setState({
        desc: this.state.lang.noChip
      })
      this.refs.toast.hideRule(true)
      return
    }
    let res = await this.ramadan.unLockJigsaw()
    this.initChips()
    const list = this.state.chipList
    list.push(res)
    this.setState({
      chipList: list
    })
    this.setState({
      desc: this.state.lang.unlockSuc
    })
    this.refs.toast.hideRule(true)
    let rwObjList = await this.ramadan.getJigsawRewardObj()
    console.log(rwObjList, 'rwObjList')
    if (rwObjList && rwObjList[0] && rwObjList[0].canGet) {
      this.setState({
        isCanGet1: true
      })
    }
    this.setState({
      rwObjList: rwObjList
    })
  }

  async onTaskGet(taskType) {
    let res = await this.ramadan.getJigsawChip(taskType)
    console.log(res);
    if (res == 0) {
      console.log("领取成功")
      this.initChips()
      this.setState({
        desc: this.state.lang.getSuc
      })
      this.refs.toast.hideRule(true)
    }
    if (res == 1) {
      console.log("已经领取")
      this.setState({
        desc: this.state.lang.getDown
      })
      this.refs.toast.hideRule(true)
    }
    if (res == 2) {
      console.log("条件未达到")
      this.setState({
        desc: this.state.lang.notask
      })
      this.refs.toast.hideRule(true)
      return
    }
  }

  onTaskGo(taskType) {
    this.setState({
      shareState: true
    })
  }

  onMore() {
    this.setState({
      shareState: true
    })
  }

  onShare(type) {
    switch (type) {
      case 1:
        this.shareLink()
        console.log(1)
        break
      case 2:
        this.shareWhatsapp()
        console.log(2)
        break
      case 3:
        this.shareSnap()
        console.log(3)
        break
      case 4:
        this.shareIns()
        console.log(4)
        break
      case 5:
        this.shareFackBook()
        console.log(5)
        break
    }
  }


  async shareLink() {
    shareToLink(this.state.codeMain)
  }
  async shareWhatsapp() {
    shareToWhatsapp(this.state.codeMain)
  }
  async shareSnap() {
    shareToSnap(this.state.codeMain)
  }
  async shareIns() {
    shareToIns(this.state.codeMain)
  }
  async shareFackBook() {
    shareToFaceBook(this.state.codeMain)
  }

  shareComp() {
    return (
      <div className="ramadan-jigsaw-share"
        onClick={() => { this.setState({ shareState: false }) }}>
        <div className="ramadan-jigsaw-share-shadow"
          style={{ display: `${this.state.shareState ? "block" : "none"}` }}></div>
        <div className={`ramadan-jigsaw-share-main ${this.state.shareState ? "active" : ""}`}>
          <div className="line"></div>
          <div className="title">{this.state.lang.share}</div>
          <div className={`content`}>
            <img className='item' src="/img/activity/ramadan/jigsaw/link.png" alt="" onClick={() => this.onShare(1)} />
            <img className='item' src="/img/activity/ramadan/jigsaw/whatsapp.png" alt="" onClick={() => this.onShare(2)} />
            {/* <img className='item' src="/img/activity/ramadan/jigsaw/snap.png" alt="" onClick={() => this.onShare(3)} />
          <img className='item' src="/img/activity/ramadan/jigsaw/ins.png" alt="" onClick={() => this.onShare(4)} />
          <img className='item' src="/img/activity/ramadan/jigsaw/fb.png" alt="" onClick={() => this.onShare(5)} /> */}
          </div>
        </div>
      </div>
    )
  }

  jigsawShowComp() {
    return (
      <div className="ramadan-jigsaw-content">
        {/* 未激活底部拼图 */}
        <div className="ramadan-jigsaw-content-main-box">
          <div className="ramadan-jigsaw-content-main-wrap-inactive">
          </div>
        </div>
        {/* 激活拼图 */}
        <div className="ramadan-jigsaw-content-main-box2">
          <div className="ramadan-jigsaw-content-main-wrap-active">
            <div className={`jigsaw-item1 ${this.state.chipList && this.state.chipList.includes(1) ? `jigsaw-item${1}-active` : ""}`}></div>
            <div className={`jigsaw-item2 ${this.state.chipList && this.state.chipList.includes(2) ? `jigsaw-item${2}-active` : ""}`}></div>
            <div className={`jigsaw-item3 ${this.state.chipList && this.state.chipList.includes(3) ? `jigsaw-item${3}-active` : ""}`}></div>
            <div className={`jigsaw-item4 ${this.state.chipList && this.state.chipList.includes(4) ? `jigsaw-item${4}-active` : ""}`}></div>
            <div className={`jigsaw-item5 ${this.state.chipList && this.state.chipList.includes(5) ? `jigsaw-item${5}-active` : ""}`}></div>
            <div className={`jigsaw-item6 ${this.state.chipList && this.state.chipList.includes(6) ? `jigsaw-item${6}-active` : ""}`}></div>
            <div className={`jigsaw-item7 ${this.state.chipList && this.state.chipList.includes(7) ? `jigsaw-item${7}-active` : ""}`}></div>
            <div className={`jigsaw-item8 ${this.state.chipList && this.state.chipList.includes(8) ? `jigsaw-item${8}-active` : ""}`}></div>
            <div className={`jigsaw-item9 ${this.state.chipList && this.state.chipList.includes(9) ? `jigsaw-item${9}-active` : ""}`}></div>
          </div >
        </div >
        {/* 全部碎片数量展示 */}
        <div className="ramadan-jigsaw-content-title">
          {this.state.lang.chips} x{this.state.chips}
        </div>
        {/* 碎片显示模块 */}
        <div className="ramadan-jigsaw-content-item-list-wrap">
          <div className="ramadan-jigsaw-content-item-list">
            <Swiper slidesPerView={4}>
              {
                this.state.chipsList.map((item, index) => {
                  return (
                    <SwiperSlide>
                      <div className="ramadan-jigsaw-content-item" key={index}>
                        <img src="/img/activity/ramadan/jigsaw/fra.png" alt="" />
                      </div>
                    </SwiperSlide>
                  )
                })
              }
            </Swiper>
          </div>
        </div>
      </div >
    )
  }

  render() {
    return (
      <div className={`ramadan-jigsaw-wrap-main ${this.state.language == 'ar' && "arlang"}`}>

        <Toast ref="toast" toastContent={this.state.desc} />

        {/* 分享模块 */}
        {this.shareComp()}

        {/* banner模块 */}
        {this.bannerComp()}

        {/* cd模块 */}
        {this.cdComp()}

        {/* 拼图模块 */}
        {this.jigsawShowComp()}

        {/* 提示 */}
        <div className="ramadan-jigsaw-more-tips">
          {this.state.lang.moreChips}
        </div>
        {/* tab栏 */}
        <div className="ramadan-jigsaw-tab">
          <div className="ramadan-jigsaw-tab-item" onClick={() => { this.onMore() }}>
            <img src="/img/activity/ramadan/jigsaw/go.png" alt="" />
            <span>{this.state.lang.more}</span>
          </div>
          <div className="ramadan-jigsaw-tab-item" onClick={() => { this.onUnLockJigsaw() }}>
            <span>{this.state.lang.unlock}</span>
          </div>
        </div>

        <div className="ramadan-jigsaw-task">
          {/* 规则按钮 */}
          <RuleButton
            lang={this.state.lang}
            slotButtonComp={() => {
              return (
                <div className="ramadan-jigsaw-banner-rule">
                  <div className="question">?</div>
                  <span>{this.state.lang.rules}</span>
                </div>)
            }}
            slotContentComp={this.ruleContentComp} />
          {/* 标题 */}
          <div className="ramadan-jigsaw-task-title">
            {this.state.lang.task}
          </div>
          {/* 任务内容 */}
          <div className="ramadan-jigsaw-task-list">
            {
              this.state.taskList && this.state.taskList.map((item, index) => {
                const prog = 100 - item.val / item.condition * 100
                return (
                  <div className="ramadan-jigsaw-task-item" key={index}>
                    <div className="ramadan-jigsaw-task-item-pic">
                      <span>x{item.fragment}</span>
                      <img src="/img/activity/ramadan/jigsaw/fra.png" alt="" />
                    </div>
                    <div className="ramadan-jigsaw-task-item-center">
                      <div
                        style={{ direction: `${this.state.language == 'ar' ? "rtl" : ""}` }}
                        className="ramadan-jigsaw-task-item-center-title">{item.desc}</div>
                      <div className="ramadan-jigsaw-task-item-center-pro">
                        <div className="ramadan-jigsaw-task-item-center-pro-item"
                          style={{ transform: `translateX(-${prog}%)` }}></div>
                      </div>
                      <div className="ramadan-jigsaw-task-item-center-txt">{item.val}/{item.condition}</div>
                    </div>
                    <div className="ramadan-jigsaw-task-item-btn">
                      <div className="get" onClick={() => { this.onTaskGet(item.taskType) }}>{this.state.lang.get}</div>
                      {
                        item.fragment >= 3 && (
                          <div className="go" onClick={() => { this.onTaskGo(item.taskType) }}>
                            <img src="/img/activity/ramadan/jigsaw/go.png" alt="" />
                          </div>
                        )
                      }
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>

        <div className="ramadan-jigsaw-cpr">
          The copyright of this event belongs to App
        </div>

        <div style={{ display: "none" }}>
          <img src="/img/activity/ramadan/jigsaw/rule_bg.png" alt="" />
        </div>

      </div >
    )
  }
}


// WEBPACK FOOTER //
// src/pages/activity/ramadanJigsaw/index.js